export default __webpack_public_path__ + "static/media/Cigna-logo.5270c422.jpg";